import { render } from "./ImportXmlFile.vue?vue&type=template&id=0b75ba27&scoped=true&ts=true"
import script from "./ImportXmlFile.vue?vue&type=script&lang=ts"
export * from "./ImportXmlFile.vue?vue&type=script&lang=ts"

import "./ImportXmlFile.vue?vue&type=style&index=0&id=0b75ba27&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b75ba27"]])

export default __exports__